import { render, staticRenderFns } from "./CouponReceive.vue?vue&type=template&id=736a0ca9&scoped=true&"
import script from "./CouponReceive.vue?vue&type=script&lang=js&"
export * from "./CouponReceive.vue?vue&type=script&lang=js&"
import style0 from "./CouponReceive.vue?vue&type=style&index=0&id=736a0ca9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736a0ca9",
  null
  
)

export default component.exports